import { render, staticRenderFns } from "./StaffAwayAssignment.vue?vue&type=template&id=6b275999&scoped=true&"
import script from "./StaffAwayAssignment.vue?vue&type=script&lang=js&"
export * from "./StaffAwayAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b275999",
  null
  
)

export default component.exports